import type { ServiceAreaRecord } from '@navio/nsdk';
import type { MultiPolygon } from 'noddi-types';
import { noddiColors } from 'noddi-ui-common';
import { FitMapToCoordinates } from 'noddi-web';
import { Polygon as LeafletPolygon } from 'react-leaflet';

type Props = {
  serviceAreas: ServiceAreaRecord[];
};

export const DeliveryMapContent = ({ serviceAreas }: Props) => {
  const coordinates = serviceAreas.flatMap(({ multiPolygon }) => (multiPolygon as MultiPolygon).flat(2));

  return (
    <>
      <FitMapToCoordinates coordinates={coordinates} />
      {serviceAreas.map(({ id, multiPolygon }) => (
        <ServiceAreaPolygon key={id} multiPolygon={multiPolygon as MultiPolygon} />
      ))}
    </>
  );
};

const ServiceAreaPolygon = ({ multiPolygon }: { multiPolygon: MultiPolygon }) => (
  <LeafletPolygon
    positions={multiPolygon}
    pathOptions={{
      fillColor: noddiColors.success,
      opacity: 0,
      fillOpacity: 0.35
    }}
  />
);
